import React, {Fragment, useEffect, useRef, useState} from "react";
import { useDispatch, useSelector } from 'react-redux';
import {
    getGateSwitcherSensors,
    getSensors,
    getSensorsByType,
    selectSensor,
    setSensorsFilters
} from '../store/actions/sensorsActions';
import { getAllFields, getFields } from '../store/actions/fieldsActions';
import { filterUser } from "../store/actions/usersActions";
import {
    getStatusColor,
    isCompanyAdmin,
    isCustomer,
    isDemoUser,
    isCompanyUser,
    isDistributorAdmin,
    isSuperAdmin,
    getLoggedUserId
} from '../helpers/helpers';
import './Sensor.scss';

import Spinner from './_common/Spinner';
import List from './_common/List';
// import SensorsMap from './SensorsMap';
import {ReactComponent as CardboardIcon} from "../assets/icons/cardboardIcon.svg";
import {ReactComponent as SatteliteIcon} from "../assets/icons/satelliteIcon.svg";
import CommunitySensorModal from "./CommunitySensorModal";
import MapView from "./Maps/MapView";
import {toggleModal} from "../store/actions/toggleModalActions";
import DetailsModal from "./_common/DetailsModal";
import SensorDetails from "./SensorDetails";

const selector = state => {
    const { language, sensors, modalState, fields, users } = state;
    return {
        t: language.translator,
        pending: sensors.pending,
        sensors: sensors.sensors,
        antennas: sensors.antennas,
        sensorTypes: sensors.sensorTypes,
        page: sensors.page,
        pageCount: sensors.pageCount,
        itemsCount: sensors.itemsCount,
        selected: sensors.selected,
        filters: sensors.filters,
        modalState: modalState,
        fields: fields.fields,
        filteredUser: users.filtered,
    }
};

const Sensor = props => {
    const {
        sensorPicker,
        selectSensorPicker,
        sensorPickerType,
        sensorPickerEnum,
        sensorPickerName,
        toggleSensorPicker,
        userId,
        gateSwitcherSensors,
        groupSelection,
        selectedSensorIds = [],
        onSensorSelectionChange,
        onFinishSelection
    } = props;
    const { t, pending, sensors, antennas, page, pageCount, itemsCount, modalState, selected, filters, fields, filteredUser,sensorTypes } = useSelector(selector);
    const dispatch = useDispatch();
    const [filter, setFilter] = useState('ALL');
    const [search, setSearch] = useState('');
    // const [hideMap, setHideMap] = useState(isSuperAdmin() || isCompanyAdmin() || isDistributorAdmin());
    const [hideMap, setHideMap] = useState(true);
    const [latSearch, setLatSearch] = useState('');
    const [lonSearch, setLonSearch] = useState('');
    const [itemsPerPage, setItemsPerPage] = useState(hideMap  ? 10 : 3);
    const [mapHasBeenClicked, setMapHasBeenClicked] = useState(false);
    const [showTypeFilterOptions, setShowTypeFilterOptions] = useState(false);
    const [typeFilter, setTypeFilter] = useState({name: '', id: ''});
    const [satelliteView, setSatelliteView] = useState(false);
    const [mapCenter, setMapCenter] = useState({lat: 52.2297, lng: 21.0122});
    const [centeredMapOnSensor, setCenteredMapOnSensor] = useState(null)

    const prevLatRef = useRef();
    const prevLonRef = useRef();

    const [isTabletOrLess, setIsTabletOrLess] = useState(checkScreenSize());
    function checkScreenSize() {
        const breakpoint = 932;
        return window.innerWidth <= breakpoint;
    }

    useEffect(() => {
        if (sensors && sensors.length > 0) {
            const { lat, lon } = sensors[0];

            if (lat !== prevLatRef.current || lon !== prevLonRef.current) {
                setCenteredMapOnSensor({ lat, lng: lon });

                // Update the previous values
                prevLatRef.current = lat;
                prevLonRef.current = lon;
            }
        }
    }, [sensors]);

    // useEffect(() => {
    //     if(sensors && sensors.length > 0) {
    //         if(sensors[0].lat && sensors[0].lon) {
    //             setCenteredMapOnSensor({lat:sensors[0].lat, lng: sensors[0].lon})
    //         }
    //     }
    // },[sensors])
    const switchMapView = () => {
        setSatelliteView(!satelliteView);
    }
    const closeModal = () => {
        dispatch(toggleModal(false, ''));
    };

    const openSensorDetails = marker => {
        const sensor = sensors.find(item => item.id === marker.id);

        if (sensor) {
            dispatch(selectSensor(sensor, page));
            dispatch(toggleModal(true, 'Sensor details'));
        }
    };



    useEffect(() => {
        if(!sensorPicker) {
            if(isCompanyAdmin() || isSuperAdmin()) {
                dispatch(filterUser({}));
                dispatch(setSensorsFilters({active: 'ALL', itemsPerPage: hideMap ? 10 : 3, search: '', lat: null, lon: null, sensorType: ''}))
                dispatch(getAllFields());
                dispatch(getSensors(1, itemsPerPage, filter, 0, search, null, null, null));
            } else {
                dispatch(setSensorsFilters({active: 'ALL', itemsPerPage: hideMap ? 10 : 3, search: '', lat: null, lon: null, sensorType: ''}))
                dispatch(getFields());
                dispatch(getSensors(1, itemsPerPage, filter, 0, search, null, null, null));
            }
            closeModal()
        } else {
            if(gateSwitcherSensors) {
                dispatch(getGateSwitcherSensors(sensorPickerEnum, userId ? userId : getLoggedUserId()))
            } else {
                dispatch(getSensorsByType(sensorPickerEnum, userId ? userId : getLoggedUserId()))
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const selectSensorPick = (item) => {
        selectSensorPicker(sensorPickerType, item.id, sensorPickerName, item.name)
    }

    let sensorMarkers = [];

    if(sensors.length) {
        sensors.forEach(sensor => {
            if (sensor.lat && sensor.lon) {
                sensorMarkers.push(
                    {
                        lat: sensor.lat,
                        lng: sensor.lon,
                        color: getStatusColor(sensor.temperatureStatus),
                        name: sensor.name,
                        loraIdentifier: sensor.loraIdentifier,
                        temperature: sensor.temperature,
                        humidity: sensor.measurements.length ? sensor.measurements[0].humidity : '',
                        date: sensor.measurements.length ? sensor.measurements[0].dateTimeCreated.replace('T') : '',
                        id: sensor.id
                    }
                )
            }
        });
    }

    let antennasMarkers = []
    if(antennas && antennas.length) {
        antennas.forEach(antenna => {
            if (antenna.lat && antenna.lon) {
                antennasMarkers.push(
                    {
                        lat: antenna.lat,
                        lng: antenna.lon,
                        color: '#00aed2',
                        name: antenna.antennaName,
                        gatewayCode: antenna.gatewayCode,
                        id: antenna.id
                    }
                )
            }
        });
    }

    const checkIfUser = () => {
        return isDemoUser() || isCustomer() || isCompanyUser() || isTabletOrLess;
    }

    const getCoordinatesFromMap = (latlng) => {
        setMapHasBeenClicked(true);
        setLatSearch(latlng.lat);
        setLonSearch(latlng.lng);
    };

    const determineGetSensorsForList = () => {
        if(!sensorPicker) {
            return getSensors()
        }
        if(gateSwitcherSensors) {
           return getGateSwitcherSensors(sensorPickerEnum, userId ? userId : getLoggedUserId())
        } else {
            return getSensorsByType(sensorPickerEnum, userId ? userId : getLoggedUserId())
        }
    }

    const handleStatusFilterChange = event => {
        const status = event.target.value;

        dispatch(setSensorsFilters({
            active: status,
            itemsPerPage,
            search: filters.search,
            lat: latSearch,
            lon: lonSearch,
            sensorType: typeFilter.name
        }));
        setFilter(status);
        dispatch(getSensors(
            1,
            itemsPerPage,
            status,
            filteredUser.id ? filteredUser.id : 0,
            filters.search,
            latSearch,
            lonSearch,
            typeFilter.name
        ));
    };

    return (
        <div style={sensorPicker ? { minWidth: '80vw', padding: '0 30px 50px'} : null} className='sensor'>
            {isTabletOrLess && (
                <div className="mMapListWrapper">
                    <div
                        onClick={() => setHideMap(!hideMap)}
                        className={!hideMap ? "mMapListItem" : "mMapListItem mMapListItem--selected"}>
                        {t.gettext('List')}
                    </div>
                    <div className={hideMap ? "mMapListItem" : "mMapListItem mMapListItem--selected"}
                         onClick={() => setHideMap(!hideMap)}
                    >
                        {t.gettext('Map')}
                    </div>
                </div>
            )}
            {!sensorPicker &&
                <div className={!hideMap ? 'sensorMap sensorMap--expanded' : 'sensorMap'}>
                    <MapView
                        zoom={5.8}
                        // center={{lat: 52.2297, lng: 21.0122}}
                        center={mapCenter}
                        markers={sensorMarkers}
                        antennasMarkers={groupSelection ? [] : antennasMarkers}
                        getCoordinates={getCoordinatesFromMap}
                        mapHasBeenClicked={mapHasBeenClicked}
                        satellite={satelliteView}
                        centeredMapOnSensor={centeredMapOnSensor}
                        onMarkerPopupClick={openSensorDetails}
                    />
                    {!hideMap && (
                        <div className="changeSatelliteContainer">
                            <button className='drawFieldButton' onClick={switchMapView}>
                                {!satelliteView ? <SatteliteIcon/> : <CardboardIcon/>}
                            </button>
                        </div>
                    )}
                    {!isTabletOrLess && (
                        <div
                            className='hideMapButton'
                            onClick={() => {
                                dispatch(setSensorsFilters({
                                    active: filter,
                                    itemsPerPage: itemsPerPage,
                                    search: filters.search,
                                    lat: latSearch,
                                    lon: lonSearch,
                                    sensorType: typeFilter.name
                                }))
                                dispatch(getSensors(1, itemsPerPage, filter, filteredUser.id ? filteredUser.id : 0, filters.search, latSearch, lonSearch, typeFilter.name));
                                setHideMap(!hideMap)
                            }}
                        >
                        <span className='material-icons hideMapButtonIcon'>
                            {hideMap ? 'expand_more' : 'expand_less'}
                        </span>
                        </div>
                    )}
                </div>
            }

            {(!sensorPicker || groupSelection
                // && !checkIfUser()
            ) && (
                <form style={sensorPicker ? {minHeight: '50px'} : null} className='sensorFilter'>
                    <select
                        className='statusFilterSelect'
                        aria-label={t.gettext('Sensor status')}
                        value={filter}
                        onChange={handleStatusFilterChange}
                    >
                        <option value='ALL'>{t.gettext('All')}</option>
                        <option value='ACTIVE'>{t.gettext('Active')}</option>
                        <option value='NOT_ACTIVE'>{t.gettext('Not Active')}</option>
                        <option value='NO_MEASUREMENTS'>{t.gettext('No Measurements')}</option>
                    </select>
                        <div
                            className='filterTypeFormSelect'
                            onClick={() => setShowTypeFilterOptions(!showTypeFilterOptions)}
                        >
                            <div className='filterTypeFormSelectText'>
                                {typeFilter.name ? typeFilter.name : t.gettext('Sensor type')}
                            </div>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                {!isDistributorAdmin() &&
                                    <i className="material-icons dropDownIcon">
                                        {showTypeFilterOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                                    </i>
                                }
                                <span
                                    className='material-icons cancelTypeIcon'
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        dispatch(setSensorsFilters({
                                            active: filter,
                                            itemsPerPage,
                                            search: filters.search,
                                            lat: latSearch,
                                            lon: lonSearch,
                                            sensorType: ''
                                        }));
                                        setTypeFilter({name: '', id: ''});
                                        dispatch(getSensors(1, itemsPerPage, filter, filteredUser.id ? filteredUser.id : 0, '', latSearch, lonSearch, ''));
                                    }}
                                >
                            cancel
                            </span>
                            </div>


                            {showTypeFilterOptions &&
                                <div className='filterTypeFormSelectOptions'>
                                    {sensorTypes.map((item, index) => (
                                        <div
                                            className='filterTypeFormSelectOption'
                                            key={index}
                                            onClick={() => {
                                                setTypeFilter({name: item.name, id: item.id})
                                                dispatch(setSensorsFilters({
                                                    active: filter,
                                                    itemsPerPage,
                                                    search: filters.search,
                                                    lat: latSearch,
                                                    lon: lonSearch,
                                                    sensorType: item.name
                                                }));
                                                dispatch(getSensors(1, itemsPerPage, filter, filteredUser.id ? filteredUser.id : 0, filters.search, latSearch, lonSearch, item.name));
                                            }}
                                        >
                                            {item.name}
                                        </div>
                                    ))}
                                </div>
                            }
                        </div>

                        <div style={isTabletOrLess ? {width: '100%', paddingRight: '10px', marginTop: '10px'} : null} className='searchInputWrapper'>
                            <input
                                type='text'
                                className='sensorSearchInput'
                                placeholder={t.gettext('Search')}
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                            />
                            {filters.search
                                ? <span
                                    style={isTabletOrLess ? {right: '15px'} : null}
                                    className='material-icons sensorSearchCancelButton'
                                    onClick={() => {
                                        dispatch(setSensorsFilters({
                                            active: filter,
                                            itemsPerPage,
                                            search: '',
                                            lat: latSearch,
                                            lon: lonSearch,
                                            sensorType: typeFilter.name
                                        }));
                                        setSearch('');
                                        dispatch(getSensors(1, itemsPerPage, filter, filteredUser.id ? filteredUser.id : 0, '', latSearch, lonSearch, typeFilter.name));
                                    }}
                                >
                            cancel
                        </span>
                                : null
                            }
                        </div>

                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <label htmlFor='latSearch' className={'latLonSearchLabel'}>
                            {t.gettext('Lat')}
                        </label>
                        <div className='searchInputWrapper'>
                            <input
                                id='latSearch'
                                type='number'
                                min={-90}
                                max={90}
                                className='sensorSearchInput sensorSearchInputLatLon'
                                value={latSearch}
                                onChange={e => setLatSearch(e.target.valueAsNumber)}
                            />
                            {filters.lat
                                ? <span
                                    className='material-icons sensorSearchCancelButton'
                                    onClick={() => {
                                        dispatch(setSensorsFilters({
                                            active: filter,
                                            itemsPerPage,
                                            search,
                                            lat: null,
                                            lon: lonSearch,
                                            sensorType: typeFilter.name
                                        }));
                                        setLatSearch('');
                                        dispatch(getSensors(1, itemsPerPage, filter, filteredUser.id ? filteredUser.id : 0, search, null, lonSearch, typeFilter.name));
                                    }}
                                >
                            cancel
                        </span>
                                : null
                            }
                        </div>
                    </div>


                    <label htmlFor='lonSearch' className={'latLonSearchLabel'}>
                        {t.gettext('Lon')}
                    </label>
                    <div className='searchInputWrapper'>
                        <input
                            id='lonSearch'
                            type='number'
                            min={-180}
                            max={180}
                            className='sensorSearchInput sensorSearchInputLatLon'
                            value={lonSearch}
                            onChange={e => setLonSearch(e.target.valueAsNumber)}
                        />
                        {filters.lon
                            ? <span
                                className='material-icons sensorSearchCancelButton'
                                onClick={() => {
                                    dispatch(setSensorsFilters({
                                        active: filter,
                                        itemsPerPage,
                                        search,
                                        lat: latSearch,
                                        lon: null,
                                        sensorType: typeFilter.name
                                    }));
                                    setLonSearch('');
                                    dispatch(getSensors(1, itemsPerPage, filter, filteredUser.id ? filteredUser.id : 0, search, latSearch, null, typeFilter.name));
                                }}
                            >
                            cancel
                        </span>
                            : null
                        }
                        </div>

                        <button
                            className='sensorSearchButton'
                            onClick={e => {
                                e.preventDefault();
                                setFilter('ALL');
                                dispatch(setSensorsFilters({
                                    active: 'ALL',
                                    itemsPerPage,
                                    search,
                                    lat: latSearch,
                                    lon: lonSearch,
                                    sensorType: typeFilter.name
                                }))
                                dispatch(getSensors(1, itemsPerPage, 'ALL', filteredUser.id ? filteredUser.id : 0, search, latSearch, lonSearch, typeFilter.name))
                            }}
                            disabled={!search && (!latSearch || !lonSearch)}
                        >
                            {t.gettext('SEARCH')}
                        </button>
                        {!sensorPicker && (
                            <Fragment>
                                <label htmlFor='itemsPerPage' className={'itemsPerPageLabel'}>
                                    {t.gettext('Items per page')}
                                </label>
                                <input
                                    type='number'
                                    id='itemsPerPage'
                                    className='sensorSearchInput itemsPerPageInput'
                                    min={1}
                                    step={1}
                                    defaultValue={itemsPerPage}
                                    onChange={e => {
                                        e.preventDefault();
                                        if (e.target.value) {
                                            setItemsPerPage(e.target.value < 1 ? 1 : e.target.value);
                                            dispatch(setSensorsFilters({
                                                active: filter,
                                                itemsPerPage: itemsPerPage,
                                                search,
                                                lat: latSearch,
                                                lon: lonSearch,
                                                sensorType: typeFilter.name
                                            }))
                                            dispatch(
                                                getSensors(
                                                    1,
                                                    e.target.value < 1 ? 1 : e.target.value,
                                                    filter,
                                                    filteredUser.id ? filteredUser.id : 0,
                                                    search,
                                                    latSearch,
                                                    lonSearch,
                                                    typeFilter.name
                                                )
                                            )
                                        }
                                    }}
                                />
                            </Fragment>
                        )}
                    {groupSelection &&
                        <button
                            type='button'
                            className='finishSensorSelectionButton'
                            onClick={onFinishSelection}
                        >
                            {t.gettext('Finish selection')}
                        </button>
                    }
                </form>
                )}
            <div className={hideMap ? 'sensorList sensorList--expanded' : 'sensorList'}>
                {pending
                    ? <div className='page'>
                        <Spinner size={300}/>
                    </div>
                    : <List
                        roundTopCorners
                        items={sensors}
                        page={page}
                        itemsPerPage={itemsPerPage}
                        pageCount={pageCount}
                        itemsCount={itemsCount}
                        columnsNames={groupSelection
                            ? ['Lora Identifier', 'Sensor Name', 'Last Measurement Time', 'User Name', 'In group']
                            : checkIfUser() ? ['Sensor Name', 'Last Measurement Time', 'Is Active'] : ['Lora Identifier', 'Sensor Name', 'Last Measurement Time', 'User Name', 'Is Active']}
                        columns={groupSelection
                            ? ['loraIdentifier', 'name', 'measurements', 'userName', 'inGroup']
                            : checkIfUser() ? ['name', 'measurements', 'active'] : ['loraIdentifier', 'name', 'measurements', 'userName', 'active']}
                        columnsWidths={checkIfUser() ? ['40%', '50%', '10%'] : ['20%', '30%', '30%', '20%', '10%']}
                        filter={filter}
                        measurementTimeColumn={groupSelection ? 3 : checkIfUser() ? 2 : 3}
                        booleanColumn={groupSelection ? null : checkIfUser() ? 3 : 5}
                        selectableColumn={groupSelection ? 5 : null}
                        isItemSelected={item => selectedSensorIds.includes(item.id)}
                        onItemSelectionChange={onSensorSelectionChange}
                        getItemsMethod={getSensors}
                        picker={sensorPicker}
                        selectItemMethod={groupSelection ? null : sensorPicker ? selectSensorPick : selectSensor}
                        onSelectModalName={groupSelection ? null : sensorPicker ? toggleSensorPicker : 'Sensor details'}
                        userId={sensorPicker ? userId ? userId : getLoggedUserId() : filteredUser.id ? filteredUser.id : 0}
                        search={filters.search}
                        lat={filters.lat}
                        lon={filters.lon}
                        sensorType={sensorPicker ? sensorPickerEnum : typeFilter.name}

                    />
                }

                {(modalState.flag && modalState.modal === 'Sensor details') &&
                    <DetailsModal
                        isTabletOrLess={isTabletOrLess}
                    >
                        <SensorDetails
                            sensor={selected.sensor}
                            fields={fields}
                            numberPerPage={hideMap ? 10 : 3}
                            filter={filter}
                            userId={filteredUser.id ? filteredUser.id : ''}
                            loadSensors={() => dispatch(getSensors(1, itemsPerPage, filter, filteredUser.id ? filteredUser.id : 0, search, latSearch, null, typeFilter.name))}
                        />
                    </DetailsModal>
                }

                {(modalState.flag && modalState.modal === 'Add community sensor') && (
                    <CommunitySensorModal
                        sensor={selected.sensor}
                        fields={fields}
                        numberPerPage={hideMap ? 10 : 3}
                        filter={filter}
                        userId={filteredUser.id ? filteredUser.id : ''}
                    />
                )}
            </div>
        </div>
    );
};

export default Sensor;
